/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidatorHistoryPoint
 */
export interface ValidatorHistoryPoint {
    /**
     * The epoch number.
     * @type {number}
     * @memberof ValidatorHistoryPoint
     */
    epoch: number;
    /**
     * The amount of tokens that were delegated to this validator account,
     * at the start of this epoch, and are NOT in the process of debonding.
     * @type {string}
     * @memberof ValidatorHistoryPoint
     */
    active_balance?: string;
    /**
     * The shares of tokens that were delegated to this validator account,
     * at the start of this epoch, and are NOT in the process of debonding.
     * @type {string}
     * @memberof ValidatorHistoryPoint
     */
    active_shares?: string;
    /**
     * The amount of tokens that were delegated to this validator account
     * at the start of this epoch, but are also in the process of debonding
     * (i.e. they will be unstaked within ~2 weeks).
     * @type {string}
     * @memberof ValidatorHistoryPoint
     */
    debonding_balance?: string;
    /**
     * The shares of tokens that were delegated to this validator account
     * at the start of this epoch, but are also in the process of debonding
     * (i.e. they will be unstaked within ~2 weeks).
     * @type {string}
     * @memberof ValidatorHistoryPoint
     */
    debonding_shares?: string;
    /**
     * The number of accounts that have delegated token to this account.
     * @type {number}
     * @memberof ValidatorHistoryPoint
     */
    num_delegators?: number;
}

export function ValidatorHistoryPointFromJSON(json: any): ValidatorHistoryPoint {
    return ValidatorHistoryPointFromJSONTyped(json, false);
}

export function ValidatorHistoryPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorHistoryPoint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'epoch': json['epoch'],
        'active_balance': !exists(json, 'active_balance') ? undefined : json['active_balance'],
        'active_shares': !exists(json, 'active_shares') ? undefined : json['active_shares'],
        'debonding_balance': !exists(json, 'debonding_balance') ? undefined : json['debonding_balance'],
        'debonding_shares': !exists(json, 'debonding_shares') ? undefined : json['debonding_shares'],
        'num_delegators': !exists(json, 'num_delegators') ? undefined : json['num_delegators'],
    };
}

export function ValidatorHistoryPointToJSON(value?: ValidatorHistoryPoint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'epoch': value.epoch,
        'active_balance': value.active_balance,
        'active_shares': value.active_shares,
        'debonding_balance': value.debonding_balance,
        'debonding_shares': value.debonding_shares,
        'num_delegators': value.num_delegators,
    };
}


